export default __webpack_public_path__ + "static/media/successful_run.434b3c80.svg";